module.exports = __webpack_public_path__ + "img/Woman_story_end.8987d286.png";